$('[data-toggle="date"]').datepicker({
    language: 'da-DK',
    format: 'dd/mm/yyyy',
    autoHide: true,
    autoPick: true
});